var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtherium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#627EEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_3128)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M8.18994 14.1618L14.1798 17.6466V4.375L8.18994 14.1618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.1792 4.375V17.6466L20.1667 14.1618L14.1792 4.375Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1798 11.4789L8.18994 14.1615L14.1798 17.6463L20.1672 14.1615L14.1798 11.4789Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1798 11.4789L8.18994 14.1615L14.1798 17.6463L20.1672 14.1615L14.1798 11.4789Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 11.4789L14.1801 14.1615L14.1797 17.6463L20.1672 14.1615L14.1797 11.4789Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 11.4789L14.1801 14.1615L14.1797 17.6463L20.1672 14.1615L14.1797 11.4789Z",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18994 15.2794L14.1798 23.5893V18.7643L8.18994 15.2794Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1792 18.7643V23.5893L20.1714 15.2794L14.1792 18.7643Z",
    fill: "#C0CBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_3128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.17,
    height: 19.25,
    fill: "white",
    transform: "translate(6.125 4.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherium);
export default __webpack_public_path__ + "static/media/Etherium.8c8ffcfdd3cfe3b0a3f3d8710244a3f9.svg";
export { ForwardRef as ReactComponent };